
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { CreateEventForm } from '@/services/Calendar/Events/forms/CreateEventForm';
import { CreateEventAttendance } from '@/services/Calendar/EventAttendance/forms/CreateEventAttendance';
import EventsRepository from '@/services/Calendar/Events';
import EventAttendanceRepository from "@/services/Calendar/EventAttendance";
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  components: {
    PageHeader,
  },
  inject: [
    'eventsRepository',
    'eventAttendanceRepository',
  ],
})
export default class EditRecurringEvent extends Vue {
  private readonly eventsRepository!: EventsRepository;
  private readonly eventAttendanceRepository!: EventAttendanceRepository;

  private loading: boolean = true;
  private dateMenu: boolean = false;

  private form: WPXFormValue<CreateEventForm> = new WPXFormValue(CreateEventForm);
  private attendanceForm: WPXFormValue<CreateEventAttendance> = new WPXFormValue(CreateEventAttendance);
  private dayType: Array<{ value: number, text: string }> = [{
    value: 0,
    text: 'National Event',
  }, {
    value: 1,
    text: 'Custom Event',
  }];
  private attendance: boolean = false;

  private async created(): Promise<void> {
    this.form.data.author = this.$store.getters.id;
    this.loading = false;
  }

  private async createEvent(): Promise<void> {
    try {
      const createdEvent = await this.eventsRepository.createEvent({
        type: Number(this.form.data.type),
        name: this.form.data.name,
        description: this.form.data.description,
        location: this.form.data.location,
        author: this.form.data.author,
        date: new Date(this.form.data.date),
        attendanceLimit: Number(this.attendanceForm.data.limit),
        signUpEndDate: new Date(this.attendanceForm.data.signUpEndDate)
      });

      this.$successDialog.show(`Event '${this.form.data.name}' has been created.`);

      this.formReset();
    } catch (err) {
      this.$errorDialog.show(err.response.data.error);
    }
  }

  private formReset(): void {
    this.form.data.name = '';
    this.form.data.description = '';
    this.form.data.location = '';
    this.form.data.author = '';
    this.form.data.date = '';
  }
}
